import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { WorkspaceConfigService } from '../../../shared/misc-services/workspace-config.service';
import { getSamplePath } from '../../../shared/misc-utilities/sampling-portal-paths';
import { Sample } from '../../../team-apis/otterdam/sample';
import { SamplingWorkspaceStore } from '../../sampling-workspace/state/sampling-workspace-store';
import { AbstractResource } from '../abstract-resource';

@Injectable()
export class SampleLoadingService extends AbstractResource {
  private samplingWorkspaceStore = inject(SamplingWorkspaceStore);
  private workspaceConfigService = inject(WorkspaceConfigService);

  async load() {
    const { projectId, sampleId } = this.workspaceConfigService;

    const sample = await lastValueFrom(
      this.request$<Sample>('GET', getSamplePath(projectId, sampleId!), {
        tokenScope: 'access_token',
        customErrorMessage: 'Failed to load sample.',
      }),
    );
    // This can be removed once the API is updated to return the id as a number
    sample.id = Number(sample.id);
    this.samplingWorkspaceStore.assign({ sample });
  }
}
